import React, { useState, useEffect } from 'react';
import { withStyles } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogActions from '@material-ui/core/DialogActions';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';

const styles = (theme) => ({
    root: {
      margin: 0,
      padding: theme.spacing(2),
    },
    closeButton: {
      position: 'absolute',
      right: theme.spacing(1),
      top: theme.spacing(1),
      color: theme.palette.grey[500],
    },
  });
  
const DialogTitle = withStyles(styles)((props) => {
    const { children, classes, onClose, ...other } = props;
    return (
        <MuiDialogTitle disableTypography className={classes.root} {...other}>
        <Typography variant="h6">{children}</Typography>
        {onClose ? (
            <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
            <CloseIcon />
            </IconButton>
        ) : null}
        </MuiDialogTitle>
    );
});

const DialogContent = withStyles((theme) => ({
root: {
    padding: theme.spacing(2),
},
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
root: {
    margin: 0,
    padding: theme.spacing(1),
},
}))(MuiDialogActions);
  
const Spinner = () => {
    return (
      <svg
        version="1.1"
        id="L9"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        x="0px"
        y="0px"
        viewBox="0 0 100 100"
        enableBackground="new 0 0 0 0"
        xmlSpace="preserve"
        style={{ width: '100px' }}
      >
        <path
          fill="#035D67"
          d="M73,50c0-12.7-10.3-23-23-23S27,37.3,27,50 M30.9,50c0-10.5,8.5-19.1,19.1-19.1S69.1,39.5,69.1,50"
        >
          <animateTransform
            attributeName="transform"
            attributeType="XML"
            type="rotate"
            dur="1s"
            from="0 50 50"
            to="360 50 50"
            repeatCount="indefinite"
          />
        </path>
      </svg>
    );
  };

export default function PlanRates(props){

    const [open, setOpen] = useState(false);
    const [ratesLoader, setRatesLoader] = useState(true); // Added ratesLoader state
    const [powerRatesLoader, setPowerRatesLoader] = useState(true); // Added ratesLoader state
    const [lunchRatesLoader, setLunchRatesLoader] = useState(true); // Added ratesLoader state
    const [planValues, setPlanValues] = useState(props.planRate);

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleNextButton = (e) => {
        props.nextStep();
    };

    const formatRates =(rates)=>{
        if (props.noGst) {
            if (props.values.ratesResult.GST && typeof props.values.ratesResult.GST === 'string') {
                const gstRate = parseFloat(props.values.ratesResult.GST);
                return (parseFloat(rates) * (1 + gstRate / 100)).toFixed(3) + ' ¢';
            } else {
                return (parseFloat(rates)).toFixed(3) + ' ¢';
            }
        } else {
            return (parseFloat(rates)).toFixed(3) + ' ¢';
        }
    }

    const renderGPPRows = () => {
        if (!props.values.ratesResult || props.values.ratesResult.loading) {
            return (
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', width: '100%', height: '100%' }}>
                    <Spinner />
                    Loading
                </div>
            );
        }

        if (props.values.ratesResult.MyQuote) {
         
         let ratesResult = props.values.ratesResult.MyQuote.QuoteBase.map(function(item, i) {
           let rateContent = null;
           let summerRate = null;
           let winterRate = null;
       
           if (item.ContentDesc === 'Fixed Daily Charges') {
               rateContent = formatRates(item.Rate) + '/Day';
           } else if (item.ContentDesc === 'Embedded generation') {
                rateContent = item.Rate + '/kWh';
           } else {
               if (item.Rate) {
                   rateContent = formatRates(item.Rate) + '/kWh';
               } else {
                   summerRate = formatRates(item.SummerRate);
                   winterRate = formatRates(item.WinterRate);
               }
           }
       
           const contentDesc = (item.ContentDesc !== 'Fixed Daily Charges' && item.ChargeDesc) && (<span> - {item.ChargeDesc}</span>);
           const extraDesc = (item.ContentDesc == 'Embedded generation') && (<span>&nbsp;(excludes GST)</span>);
           return (
                <div className="plan-box__rate-row" key={i}>
                    <div className="plan-box__rate-label">
                        <label>{item.ContentDesc}{contentDesc}{extraDesc}</label>
                    </div>
                    <div className="plan-box__rate-value">{!!rateContent && rateContent}</div>
                </div>
           );
         });

         const noGstCheckbox = <div className="plan-box__rate-row" key={1001}>
                <div className="plan-box__rate-label plan-box__rate-label--promise">
                    <label style={props.noGst ? { fontWeight: 'bold', color: '#035d67' } : {}}>{props.noGst ? 'With GST' : 'With GST'}</label>
                </div>
                <div className="plan-box__rate-value">
                    <label className="plan-checkbox">
                        <input
                            type="checkbox"
                            id="noGstCheckbox"
                            name="noGstCheckbox"
                            checked={props.noGst} // Use props.noGst
                            onChange={props.handleNoGstChange} // Use props.handleNoGstChange
                        />
                        <span className="checkmark"></span>
                    </label>
                </div>
            </div>;
         
         // Combine ratesResult and ratePromise into an array of JSX elements
         return (
             <>
                 {ratesResult}
                 {noGstCheckbox}
             </>
         );
 
        }
    }

    const renderLunchRows = () => {
        if (!props.values.lunchRatesResult || props.values.lunchRatesResult.loading) {
            return (
                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                        width: '100%',
                        height: '100%',
                    }}
                >
                    <Spinner />
                    Loading
                </div>
            );
        }
    
        if (props.values.lunchRatesResult.MyQuote) {
            const quoteItems = props.values.lunchRatesResult.MyQuote.QuoteBase;
    
            // Identify the first group ContentCode that is not 'Fixed Daily Charges' or 'Embedded generation'
            const firstGroupCode = quoteItems.find(
                item =>
                    item.ContentDesc !== 'Fixed Daily Charges' &&
                    item.ContentDesc !== 'Embedded generation'
            )?.ContentCode;
    
            // Filter items accordingly
            const filteredItems = quoteItems.filter(item => {
                return (
                    item.ContentDesc === 'Fixed Daily Charges' ||
                    item.ContentDesc === 'Embedded generation' ||
                    item.ContentCode === firstGroupCode
                );
            });
    
            const ratesResult = filteredItems.map((item, i) => {
                let rateContent = null;
    
                if (item.ContentDesc === 'Fixed Daily Charges') {
                    rateContent = formatRates(item.Rate) + '/Day';
                } else if (item.ContentDesc === 'Embedded generation') {
                    rateContent = item.Rate + '/kWh';
                } else {
                    rateContent = (Number(item.Rate) === 0 || Number(item.Rate) === 0.00)
                        ? 'Free'
                        : (item.Rate ? formatRates(item.Rate) + '/kWh' : '0');
                }
    
                const chargeDesc =
                    item.ContentDesc !== 'Fixed Daily Charges' && item.ChargeDesc ? (
                        <span>{item.ChargeDesc}</span>
                    ) : null;
                const extraDesc =
                    item.ContentDesc === 'Embedded generation' ? (
                        <span>&nbsp;(excludes GST)</span>
                    ) : null;
                const contentDesc =
                    item.ContentDesc === 'Fixed Daily Charges' ? (
                        <span>{item.ContentDesc}</span>
                    ) : null;
    
                return (
                    <div className="plan-box__rate-row" key={i}>
                        <div className="plan-box__rate-label">
                            <label>
                                {contentDesc}
                                {chargeDesc}
                                {extraDesc}
                            </label>
                        </div>
                        <div className="plan-box__rate-value">
                            {!!rateContent && rateContent}
                        </div>
                    </div>
                );
            });
    
            const noGstCheckbox = (
                <div className="plan-box__rate-row" key={1001}>
                    <div className="plan-box__rate-label plan-box__rate-label--promise">
                        <label
                            style={
                                props.noGst
                                    ? { fontWeight: 'bold', color: '#035d67' }
                                    : {}
                            }
                        >
                            {props.noGst ? 'With GST' : 'With GST'}
                        </label>
                    </div>
                    <div className="plan-box__rate-value">
                        <label className="plan-checkbox">
                            <input
                                type="checkbox"
                                id="noGstCheckbox"
                                name="noGstCheckbox"
                                checked={props.noGst}
                                onChange={props.handleNoGstChange}
                            />
                            <span className="checkmark"></span>
                        </label>
                    </div>
                </div>
            );
    
            return (
                <>
                    {ratesResult}
                    {noGstCheckbox}
                </>
            );
        }
    
        return null;
    };    

    const renderPowerRows = () => {
        if (!props.values.powerRatesResult || props.values.powerRatesResult.loading) {
            return (
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', width: '100%', height: '100%' }}>
                    <Spinner />
                    Loading
                </div>
            );
        }

        if (props.values.powerRatesResult.MyQuote) {

         let ratesResult = props.values.powerRatesResult.MyQuote.QuoteBase.map(function(item, i) {
           let rateContent = null;
           let summerRate = null;
           let winterRate = null;

           if (item.ContentDesc === 'Fixed Daily Charges') {
               rateContent = formatRates(item.Rate) + '/Day';

               const contentDesc = (item.ContentDesc !== 'Fixed Daily Charges' && item.ChargeDesc) && (<span> - {item.ChargeDesc}</span>);
               return (
                    <div className="plan-box__rate-row" key={i}>
                        <div className="plan-box__rate-label">
                            <label>{item.ContentDesc}{contentDesc}</label>
                        </div>
                        <div className="plan-box__rate-value">{!!rateContent && rateContent}</div>
                    </div>
               );
           } 
         });

         let weekdaysFirstRate = '';
         let weekdaysSecondRate = '';
         let weekdaysThirdtRate = '';
         let weekendFirstRate = '';
         let weekendSecondRate = '';
         let weekendThirdtRate = '';
         props.values.powerRatesResult.MyQuote.QuoteBase.forEach((item, i) => {
                   
             if (item.ChargeDesc === 'Weekdays Peak: 7am-11am & 5pm-9pm') {
                 weekdaysFirstRate = formatRates(item.Rate) + '/kWh';
             }
                   
             if (item.ChargeDesc === 'Weekdays Off-Peak: 11am-5pm & 9pm-11pm') {
                weekdaysSecondRate = formatRates(item.Rate) + '/kWh';
             }
                   
             if (item.ChargeDesc === 'Weekdays Night: 11pm-7am') {
                weekdaysThirdtRate = formatRates(item.Rate) + '/kWh';
             }
                   
             if (item.ChargeDesc === 'Weekends Peak: 7am-11am & 5pm-9pm') {
                weekendFirstRate = formatRates(item.Rate) + '/kWh';
             }
                   
             if (item.ChargeDesc === "Weekends Off-Peak: 11am-5pm & 9pm-11pm") {
                weekendSecondRate = formatRates(item.Rate) + '/kWh';
             }
                   
             if (item.ChargeDesc === "Weekends Night: 11pm-7am") {
                weekendThirdtRate = formatRates(item.Rate) + '/kWh';
             }
             
         });
         
         const ratePromise = <>
            <div className="plan-box__rate-row plan-box__rate-row--text" key={1000}>
                <div className="plan-box__rate-label">
                    <label>Weekdays</label>
                </div>
                <div className="plan-box__rate-value">
                    <label>&nbsp;</label>
                </div>
            </div>
            <div className="plan-box__rate-row plan-box__rate-row--text" key={1001}>
                <div className="plan-box__rate-label">
                    Peak: 7am-11am & 5pm-9pm
                </div>
                <div className="plan-box__rate-value">
                    {weekdaysFirstRate}
                </div>
            </div>
            <div className="plan-box__rate-row plan-box__rate-row--text" key={1002}>
                <div className="plan-box__rate-label">
                    Off-Peak: 11am-5pm & 9pm-11pm
                </div>
                <div className="plan-box__rate-value">
                    {weekdaysSecondRate}
                </div>
            </div>
            <div className="plan-box__rate-row plan-box__rate-row--text plan-box__rate-row--border" key={1003}>
                <div className="plan-box__rate-label">
                    Night: 11pm-7am
                </div>
                <div className="plan-box__rate-value">
                    {weekdaysThirdtRate}
                </div>
            </div>
            <div className="plan-box__rate-row plan-box__rate-row--text" key={1004}>
                <div className="plan-box__rate-label">
                    <label>Weekends</label>
                </div>
                <div className="plan-box__rate-value">
                    <label>&nbsp;</label>
                </div>
            </div>
            <div className="plan-box__rate-row plan-box__rate-row--text" key={1005}>
                <div className="plan-box__rate-label">
                    Peak: 7am-11am & 5pm-9pm
                </div>
                <div className="plan-box__rate-value">
                    {weekendFirstRate}
                </div>
            </div>
            <div className="plan-box__rate-row plan-box__rate-row--text" key={1006}>
                <div className="plan-box__rate-label">
                    Off-Peak: 11am-5pm & 9pm-11pm
                </div>
                <div className="plan-box__rate-value">
                    {weekendSecondRate}
                </div>
            </div>
            <div className="plan-box__rate-row plan-box__rate-row--text plan-box__rate-row--border" key={1007}>
                <div className="plan-box__rate-label">
                    Night: 11pm-7am
                </div>
                <div className="plan-box__rate-value">
                    {weekendThirdtRate}
                </div>
            </div>
        </>;

        const noGstCheckbox = <div className="plan-box__rate-row" key={1001}>
        <div className="plan-box__rate-label plan-box__rate-label--promise">
            <label style={props.noGst ? { fontWeight: 'bold', color: '#035d67' } : {}}>{props.noGst ? 'With GST' : 'With GST'}</label>
        </div>
        <div className="plan-box__rate-value">
            <label className="plan-checkbox">
                <input
                    type="checkbox"
                    id="noGstCheckbox"
                    name="noGstCheckbox"
                    checked={props.noGst} // Use props.noGst
                    onChange={props.handleNoGstChange} // Use props.handleNoGstChange
                />
                <span className="checkmark"></span>
            </label>
        </div>
        </div>;
         
         // Combine ratesResult and ratePromise into an array of JSX elements
         return (
             <>
                 {ratesResult}
                 {ratePromise}
                 {noGstCheckbox}
             </>
         );
        }
    }

    useEffect(()=>{
        // Simulate loading state
        if (props.values.ratesResult) {
            setRatesLoader(false);
        }
    },[props.values.ratesResult]);

    useEffect(()=>{
        // Simulate loading state
        if (props.values.powerRatesResult) {
            setPowerRatesLoader(false);
        }

    },[props.values.powerRatesResult]);

    useEffect(()=>{
        // Simulate loading state
        if (props.values.lunchRatesResult) {
            setLunchRatesLoader(false);
        }

    },[props.values.lunchRatesResult]);

    useEffect(()=>{

        //console.log('props.totalRateCount',props.totalRateCount);

    },[]);

    console.log('planValues',planValues.apiType);

    return (
        <div
        className="plan-box"
        >
            {planValues.apiType === "standard" ? (
            <>
                <div className="plan-box__item">
                    <div className="plan-box__header">
                        {props.totalRateCount <= 2 ? (
                            <>
                                <div className="plan-box__sub-header">
                                    <div dangerouslySetInnerHTML={{ __html: planValues.icon }} />
                                    <h2>{planValues.title}</h2>
                                </div>
                                <p>{planValues.summary}</p>
                            </>
                        ) : (
                            <div className="plan-box__sub-header-main">
                                <div className="plan-box__sub-header-main-left">
                                    <div className="plan-box__sub-header">
                                        <div dangerouslySetInnerHTML={{ __html: planValues.icon }} />
                                        <h2>{planValues.title}</h2>
                                    </div>
                                    <p>{planValues.summary}</p>
                                </div>
                                <div className="plan-box__sub-header-main-right">
                                    <div dangerouslySetInnerHTML={{ __html: planValues.details }}></div>
                                </div>
                            </div>
                        )}
                    </div>
                    <div className="plan-box__body">
                        <a href="#" className="plan-box__toggle" onClick={(e) => {
                            e.preventDefault();
                            const toggleBody = e.currentTarget.nextElementSibling;
                            const svg = e.currentTarget.querySelector('svg');
                            toggleBody.classList.toggle('plan-box__toggle-body--show');
                            svg.style.transform = svg.style.transform === 'rotate(180deg)' ? '' : 'rotate(180deg)';
                        }}>
                            <label>Show Rates Info</label>
                            <svg width="10" height="5" viewBox="0 0 10 5" fill="none" xmlns="http://www.w3.org/2000/svg" style={{transition: 'transform 0.3s'}}>
                                <path d="M1 0.5L5 4.5L9 0.5" stroke="#030904" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                        </a>
                        <div className="plan-box__toggle-body">
                            {props.totalRateCount <= 2 && (
                                <div dangerouslySetInnerHTML={{ __html: planValues.details }}></div>
                            )}
                            <p><a href="javascript:;" className="plan-box__link" onClick={handleClickOpen}>Find Out More</a></p>
                            <div className="plan-box__rates">
                                {renderGPPRows()}
                            </div>
                        </div>
                        {!ratesLoader && (
                            <a href="javascript:;" 
                                className="plan-box__button grey-power-plan-box_button"
                                onClick={() => {
                                props.handleChange('planType')({target: {value: planValues.title}});
                                handleNextButton();
                                }}
                            >
                                Get This Plan
                            </a>
                        )}
                    </div>
                </div>
                <Dialog onClose={handleClose} aria-labelledby="customized-dialog-title" open={open} className="diaolog-box plan-rates-modal">
                    <DialogTitle id="customized-dialog-title" onClose={handleClose}>
                        <p><div dangerouslySetInnerHTML={{ __html: planValues.icon }} /></p>
                        <h3 className="diaolog-box-heading">{planValues.title}</h3>
                        <p className="diaolog-box-subheading">{planValues.summary}</p>
                    </DialogTitle>
                    <DialogContent dividers>
                    <Typography gutterBottom>
                        <div dangerouslySetInnerHTML={{ __html: planValues.popupDetails }}></div>
                    </Typography>
                    </DialogContent>
                </Dialog>
            </>
            ) : planValues.apiType === "lunch" ? (
                <>
                <div className="plan-box__item">
                    <div className="plan-box__header">
                        {props.totalRateCount <= 2 ? (
                            <>
                                <div className="plan-box__sub-header">
                                    <div dangerouslySetInnerHTML={{ __html: planValues.icon }} />
                                    <h2>{planValues.title}</h2>
                                </div>
                                <p>{planValues.summary}</p>
                            </>
                        ) : (
                            <div className="plan-box__sub-header-main">
                                <div className="plan-box__sub-header-main-left">
                                    <div className="plan-box__sub-header">
                                        <div dangerouslySetInnerHTML={{ __html: planValues.icon }} />
                                        <h2>{planValues.title}</h2>
                                    </div>
                                    <p>{planValues.summary}</p>
                                </div>
                                <div className="plan-box__sub-header-main-right">
                                    <div dangerouslySetInnerHTML={{ __html: planValues.details }}></div>
                                </div>
                            </div>
                        )}
                    </div>
                    <div className="plan-box__body">
                        <a href="#" className="plan-box__toggle" onClick={(e) => {
                            e.preventDefault();
                            const toggleBody = e.currentTarget.nextElementSibling;
                            const svg = e.currentTarget.querySelector('svg');
                            toggleBody.classList.toggle('plan-box__toggle-body--show');
                            svg.style.transform = svg.style.transform === 'rotate(180deg)' ? '' : 'rotate(180deg)';
                        }}>
                            <label>Show Rates Info</label>
                            <svg width="10" height="5" viewBox="0 0 10 5" fill="none" xmlns="http://www.w3.org/2000/svg" style={{transition: 'transform 0.3s'}}>
                                <path d="M1 0.5L5 4.5L9 0.5" stroke="#030904" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                        </a>
                        <div className="plan-box__toggle-body">
                            {props.totalRateCount <= 2 && (
                                <div dangerouslySetInnerHTML={{ __html: planValues.details }}></div>
                            )}
                            <p><a href="javascript:;" className="plan-box__link" onClick={handleClickOpen}>Find Out More</a></p>
                            <div className="plan-box__rates">
                                {renderLunchRows()}
                            </div>
                        </div>
                        {!lunchRatesLoader && (
                            <a href="javascript:;" 
                                className="plan-box__button power-lunch-plan-box_button"
                                onClick={() => {
                                props.handleChange('planType')({target: {value: planValues.title}});
                                handleNextButton();
                                }}
                            >
                                Get This Plan
                            </a>
                        )}
                    </div>
                </div>
                <Dialog onClose={handleClose} aria-labelledby="customized-dialog-title" open={open} className="diaolog-box plan-rates-modal">
                    <DialogTitle id="customized-dialog-title" onClose={handleClose}>
                        <p><div dangerouslySetInnerHTML={{ __html: planValues.icon }} /></p>
                        <h3 className="diaolog-box-heading">{planValues.title}</h3>
                        <p className="diaolog-box-subheading">{planValues.summary}</p>
                    </DialogTitle>
                    <DialogContent dividers>
                    <Typography gutterBottom>
                        <div dangerouslySetInnerHTML={{ __html: planValues.popupDetails }}></div>
                    </Typography>
                    </DialogContent>
                </Dialog>
            </>    
            ) : (
                <>
                    <div className="plan-box__item">
                        <div className="plan-box__header">
                            {props.totalRateCount <= 2 ? (
                                <>
                                    <div className="plan-box__sub-header">
                                        <div dangerouslySetInnerHTML={{ __html: planValues.icon }} />
                                        <h2>{planValues.title}</h2>
                                    </div>
                                    <p>{planValues.summary}</p>
                                </>
                            ) : (
                                <div className="plan-box__sub-header-main">
                                    <div className="plan-box__sub-header-main-left">
                                        <div className="plan-box__sub-header">
                                            <div dangerouslySetInnerHTML={{ __html: planValues.icon }} />
                                            <h2>{planValues.title}</h2>
                                        </div>
                                        <p>{planValues.summary}</p>
                                    </div>
                                    <div className="plan-box__sub-header-main-right">
                                        <div dangerouslySetInnerHTML={{ __html: planValues.details }}></div>
                                    </div>
                                </div>
                            )}
                        </div>
                        <div className="plan-box__body">
                            <a href="#" className="plan-box__toggle" onClick={(e) => {
                                e.preventDefault();
                                const toggleBody = e.currentTarget.nextElementSibling;
                                const svg = e.currentTarget.querySelector('svg');
                                toggleBody.classList.toggle('plan-box__toggle-body--show');
                                svg.style.transform = svg.style.transform === 'rotate(180deg)' ? '' : 'rotate(180deg)';
                            }}>
                                <label>Show Rates Info</label>
                                <svg width="10" height="5" viewBox="0 0 10 5" fill="none" xmlns="http://www.w3.org/2000/svg" style={{transition: 'transform 0.3s'}}>
                                    <path d="M1 0.5L5 4.5L9 0.5" stroke="#030904" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                            </a>
                            <div className="plan-box__toggle-body">
                                {props.totalRateCount <= 2 && (
                                    <div dangerouslySetInnerHTML={{ __html: planValues.details }}></div>
                                )}
                                <p><a href="javascript:;" className="plan-box__link" onClick={handleClickOpen}>Find Out More</a></p>
                                <div className="plan-box__rates">
                                    {renderPowerRows()}
                                </div>
                            </div>
                            {!powerRatesLoader && (
                                <a 
                                    href="javascript:;"
                                    className="plan-box__button power-shift-plan-box_button"
                                    onClick={() => {
                                        props.handleChange('planType')({target: {value: planValues.title}});
                                        handleNextButton();
                                    }}
                                >
                                    Get This Plan
                                </a>
                            )}
                        </div>
                    </div>
                    <Dialog onClose={handleClose} aria-labelledby="customized-dialog-title" open={open} className="diaolog-box plan-rates-modal">
                        <DialogTitle id="customized-dialog-title" onClose={handleClose}>
                            <p><div dangerouslySetInnerHTML={{ __html: planValues.icon }} /></p>
                            <h3 className="diaolog-box-heading">{planValues.title}</h3>
                            <p className="diaolog-box-subheading">{planValues.description}</p>
                        </DialogTitle>
                        <DialogContent dividers>
                        <Typography gutterBottom>
                            <div dangerouslySetInnerHTML={{ __html: planValues.popupDetails }}></div>
                        </Typography>
                        </DialogContent>
                    </Dialog>
                </>
            )}
        </div>
    )
}
